import { MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from '../../../../redux/store';

RentalCategoryDropdown.propTypes = {
  setSubcategories: PropTypes.func.isRequired,
  orderId: PropTypes.number,
  orderStatus: PropTypes.string,
  isExistingOrder: PropTypes.bool
};
export default function RentalCategoryDropdown({setSubcategories, orderId, orderStatus, isExistingOrder}) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [category, setCategory] = useState(searchParams.get('category'));
  const [facilityId, setFacilityId] = useState(searchParams.get('facilityId'));
  const [residentId, setResidentId] = useState(searchParams.get('residentId'));
  const {
    data: { items, facilityVendors },
  } = useSelector((state) => state.rentals);
  const handleCategoryClick = (event) => {
    const selectedCategory = event.target.value;
    setCategory(selectedCategory);
    setSubcategories([]);
    if (orderId) {
      navigate(
        `/dashboard/rentals/new-rental?facilityId=${facilityId}&category=${selectedCategory}&residentId=${residentId}&orderId=${orderId}&orderStatus=${orderStatus}`
      );
    } 
    else if (isExistingOrder) {
      navigate(
        `/dashboard/rentals/new-rental?facilityId=${facilityId}&category=${selectedCategory}&residentId=${residentId}&isExistingOrder=true`
      );
    }
      else {
      navigate(
        `/dashboard/rentals/new-rental?facilityId=${facilityId}&category=${selectedCategory}&residentId=${residentId}`
      );
    }
  };

  const categoriesForFacility = items
      .filter((item) => facilityVendors.some((fv) => fv.vendorId === item.vendorId))
      .map((item) => ({
          categoryName: item.categoryName,
          categoryId: item.categoryId,
        }
      ));

  const uniqueCategories = categoriesForFacility.reduce((acc, category) => {
    if (!acc.some((item) => item.categoryName === category.categoryName)) {
      acc.push(category);
    }
    return acc;
  }, []);


  useEffect(() => {
    setCategory(searchParams.get('category'));
    setFacilityId(searchParams.get('facilityId'));
    setResidentId(searchParams.get('residentId'));
  }, [searchParams]);
  return (
    <>
      <Select
        label="Select Category"
        value={category || ''}
        onChange={handleCategoryClick}
        sx={{
          color: '#8cc53f',
          fontWeight: '15px',
          '& .MuiSelect-icon': {
            color: '#8cc53f',
          },
        }}
      >
        <MenuItem value="" disabled>
          {!uniqueCategories?.length ? 'Loading categories...' : ''}
        </MenuItem>
        {uniqueCategories.map((category) => (
          <MenuItem key={category.categoryName} value={category.categoryName}>
            {category.categoryName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
}
